import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SignalRService } from '@services/signalr/signal-rservice.service';

@Component({
  selector: 'app-mf-sidebar',
  templateUrl: './mf-sidebar.component.html',
  styleUrls: ['./mf-sidebar.component.css']
})
export class MfSidebarComponent implements OnInit {
  collapsed: boolean = false;
  showMouseHover: boolean = false;
  sidebarClass: any = "sidebar";
  @Input() mainPanelClass: any;
  @Output() mainPanelClassChange = new EventEmitter();
  menu: any = {
    options: {}
  }
  constructor(public signalRService:SignalRService) { }

  ngOnInit() {
  }

  collapseClick() {
    if (this.showMouseHover)
      this.showMouseHover = false;
    else this.collapseShow();
  }

  collapseShow() {
    this.collapsed = !this.collapsed;
    if (this.collapsed) {
      this.sidebarClass = "sidebar sidebar-collapsed";
      this.mainPanelClass = "main-panel content-collapsed";
      this.mainPanelClassChange.emit(this.mainPanelClass);
    }
    else {
      this.sidebarClass = "sidebar";
      this.mainPanelClass = "main-panel";
      this.mainPanelClassChange.emit(this.mainPanelClass);
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    },350)
   
  }

  mouseEnter() {
    if (this.collapsed) {
      this.collapseShow();
      this.showMouseHover = true;
    }
  }
  mouseLeave() {
    if (this.showMouseHover)
      this.collapseShow();
  }

}
